import { BRAND, IMAGES } from "../../data/site";
import { Button } from "../ui/button";
import { ArrowDown, Instagram } from "lucide-react";

export const Hero = () => {
    return (
        <section id="top" data-testid="hero-section" className="relative min-h-screen flex items-center overflow-hidden">
            <div className="absolute inset-0">
                <img src={IMAGES.hero} alt="Sneakers streetwear" className="h-full w-full object-cover" />
                <div className="absolute inset-0 bg-black/70" />
                <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_left,rgba(230,0,0,0.25),transparent_50%)]" />
            </div>

            <div className="relative max-w-7xl mx-auto px-6 py-32 w-full">
                <p data-testid="hero-eyebrow" className="text-[#E60000] font-bold uppercase tracking-[0.3em] text-sm mb-6">
                    Sneakers selezionate • Abbigliamento • Accessori
                </p>
                <h1 data-testid="hero-headline" className="text-5xl sm:text-7xl lg:text-8xl font-bold uppercase tracking-tighter text-white leading-[0.95] max-w-4xl">
                    Il tuo plug<br />di <span className="text-[#E60000]">fiducia.</span>
                </h1>
                <p data-testid="hero-subtext" className="mt-8 max-w-xl text-base sm:text-lg text-neutral-300 font-medium leading-relaxed">
                    Niente filtri, niente intermediari. Sneakers, abbigliamento e accessori
                    dei grandi marchi: parli direttamente con chi questo mondo lo vive ogni
                    giorno. Troviamo l'articolo giusto per te, al prezzo giusto.
                </p>
                <div className="mt-10 flex flex-wrap gap-4">
                    <Button asChild size="lg" className="rounded-sm bg-[#E60000] hover:bg-[#c40000] text-white font-bold uppercase tracking-wide hover:-translate-y-1 hover:shadow-[0_4px_20px_rgba(230,0,0,0.4)] transition-all">
                        <a href={BRAND.dmUrl} target="_blank" rel="noopener noreferrer" data-testid="hero-cta-instagram">
                            <Instagram className="mr-2 h-4 w-4" /> Scrivici in DM
                        </a>
                    </Button>
                    <Button asChild size="lg" variant="outline" className="rounded-sm border-neutral-600 bg-transparent text-white hover:bg-white/10 hover:text-white font-bold uppercase tracking-wide">
                        <a href="#contatti" data-testid="hero-cta-how">
                            Come funziona <ArrowDown className="ml-2 h-4 w-4" />
                        </a>
                    </Button>
                </div>
            </div>
        </section>
    );
};
